import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';
import { asyncConnect } from 'redux-connect';

import { isLoaded as areModulesLoaded, load as loadModules } from 'redux/modules/modules';
import { CommercialForm } from 'components';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    const promises = [];
    if (!areModulesLoaded(getState())) {
      promises.push(dispatch(loadModules()));
    }
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    modules: state.modules.data,
  })
)
@translate(['common'])
export default class AddCommercialPage extends Component {

  render() {
    const {
      t,
    } = this.props;

    const styles = require('./AddClient.scss');

    return (
      <div className={'container'}>
        <Helmet title="Creation d'un commercial" />
        <h1>{t('main.create_commercial')}</h1>
        <CommercialForm key="createCommercialForm" action="create" />
      </div>
    );
  }
}
